import { setupVfm } from './config/modal.config'
import { setupFilters } from './config/filters.config'
import { createApp } from 'vue'
import { VueCookieNext } from 'vue-cookie-next'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueClickAway from 'vue3-click-away'
import { createHead } from '@vueuse/head'
import { setupPrimeComponents } from '@/config/prime.config'
import '@/styles/fas/all.min.css'

const head = createHead()
const app = createApp(App)

setupPrimeComponents(app)
setupFilters(app)
setupVfm(app)

app
  .use(router)
  .use(store)
  .use(VueCookieNext)
  .use(i18n)
  .use(VueClickAway)
  .use(head)
  .mount('#app')
